import { Link } from "react-router-dom";

interface EventCardProps {
  slug: string;
  title: string;
  summary: string;
  cover: string;
  category: string;
  date: string;
  heat: number;
  readTime?: string;
  variant?: "grid" | "list";
}

export default function EventCard({
  slug,
  title,
  summary,
  cover,
  category,
  date,
  heat,
  readTime,
  variant = "grid",
}: EventCardProps) {
  if (variant === "list") {
    return (
      <article className="group flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200/80 bg-background-50 p-3 transition-colors hover:border-primary-300 sm:flex-row">
        <Link
          to={`/events/${slug}`}
          className="relative block h-44 w-full shrink-0 overflow-hidden rounded-md sm:h-32 sm:w-52"
          aria-label={title}
        >
          <img
            src={cover}
            alt={`${title} 相关配图`}
            title={`${title} - 每日吃瓜热门事件`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </Link>
        <div className="flex min-w-0 flex-1 flex-col justify-between py-1 pr-1">
          <div>
            <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-900">
                {category}
              </span>
              <span>{date}</span>
              {readTime && <span className="hidden sm:inline">· 约 {readTime}</span>}
            </div>
            <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
              <Link to={`/events/${slug}`} className="transition-colors hover:text-primary-700">
                {title}
              </Link>
            </h3>
            <p className="line-clamp-2 mt-2 text-sm leading-relaxed text-foreground-600">
              {summary}
            </p>
          </div>
          <div className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-fire-line text-primary-500"></i>
            <span>热度 {heat.toFixed(1)}</span>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300">
      <Link
        to={`/events/${slug}`}
        className="relative block h-48 w-full overflow-hidden md:h-52"
        aria-label={title}
      >
        <img
          src={cover}
          alt={`${title} 相关配图`}
          title={`${title} - 每日吃瓜大瓜汇总`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-foreground-950/80 px-2.5 py-1 text-[11px] font-medium text-background-50">
          {category}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span>{date}</span>
          <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-500"></i>
            {heat.toFixed(1)}
          </span>
        </div>
        <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/events/${slug}`} className="transition-colors hover:text-primary-700">
            {title}
          </Link>
        </h3>
        <p className="line-clamp-2 mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {summary}
        </p>
        <Link
          to={`/events/${slug}`}
          className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-700 transition-colors hover:text-primary-600"
        >
          查看事件脉络
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </article>
  );
}